/**
 * 포지션 코드를 표시하는 AG Grid cellRenderer 함수
 * EMPTY인 경우 텍스트만 표시하고, 그 외에는 BaseChip 컴포넌트를 사용합니다.
 *
 * @param params - AG Grid cellRenderer 파라미터
 * @param label - 포지션 코드의 표시 레이블 (EnumLabelMapper.getPositionCodeShort로 얻은 값)
 * @param BaseChip - BaseChip Vue 컴포넌트
 * @param h - Vue의 h 함수
 * @param render - Vue의 render 함수
 * @returns DOM 요소 (container)
 *
 * @example
 * ```typescript
 * import { positionCodeCellRenderer } from '@template/utils/aggrid/cellRenderer';
 * import { EnumLabelMapper } from '@template/api';
 * import { BaseChip } from '@template/ui';
 * import { h, render } from 'vue';
 *
 * const columnDef = {
 *   field: 'positionCd',
 *   cellRenderer: (params) => {
 *     const label = EnumLabelMapper.getPositionCodeShort(params.value);
 *     return positionCodeCellRenderer(params, label, BaseChip, h, render);
 *   },
 * };
 * ```
 */
export function positionCodeCellRenderer(params, label, BaseChip, h, render) {
    const container = document.createElement('div');
    const positionCode = params.value;
    // EMPTY인 경우 BaseChip 대신 텍스트만 표시
    if (positionCode === 'EMPTY') {
        container.textContent = label;
        return container;
    }
    // BaseChip 컴포넌트를 VNode로 생성
    const vnode = h(BaseChip, {
        variant: positionCode === 'LONG' ? 'red' : 'blue',
        size: 'sm',
        label: label,
    });
    // VNode를 DOM에 렌더링
    render(vnode, container);
    return container;
}
//# sourceMappingURL=cellRenderer.js.map